import React, { FC } from 'react';

interface Popups {
  children?: any;
  activeTab?: string | 'solid' | 'gradient';
  tabName?: string;
  popupWidth?: number;
  onClick?: () => void;
}

export const PopupTabs: FC<Popups> = ({
  children,
  activeTab,
  popupWidth
}: Popups) => {
  const childrenContact = React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      activeTab
    });
  });

  return (
    <div
      className='rounded-xl border border-gray-200 bg-white px-4 pb-4 pt-3 shadow-[0_10px_30px_-12px_rgba(17,24,39,0.18),0_2px_6px_-2px_rgba(17,24,39,0.08)]'
      style={{ width: `${popupWidth}px` }}
    >
      {childrenContact}
    </div>
  );
};

export const PopupTabsBody: FC<Popups> = ({ children, activeTab }) => {
  const childrenContact = React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      activeTab
    });
  });

  return <div>{childrenContact}</div>;
};

export const PopupTabsBodyItem: FC<Popups> = ({
  children,
  activeTab,
  tabName
}: Popups) => {
  if (activeTab === tabName) {
    return <div>{children}</div>;
  }

  return null;
};
